import React from 'react'
import AnimationDots from '../../AnimationDots'
import { Container } from './styles'

interface IUserWishlistInformationsItemProps {
    field: string;
    value: string | number | undefined;
    loading: boolean
}

const UserWishlistInformationsItem: React.FC<IUserWishlistInformationsItemProps> = ({ field, value, loading }) => (
    <Container>
        <p>{field}</p>
        {loading ? <AnimationDots/>:<p>{value}</p>  }
    </Container>
)


export default UserWishlistInformationsItem